var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImageUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "image-upload-icon_svg__icon",
    d: "M21.75 0H2.25A2.25 2.25 0 000 2.25v13.5A2.25 2.25 0 002.25 18h19.5A2.25 2.25 0 0024 15.75V2.25A2.25 2.25 0 0021.75 0zm.75 15.75a.75.75 0 01-.75.75H2.25a.75.75 0 01-.75-.75V2.25a.75.75 0 01.75-.75h19.5a.75.75 0 01.75.75v13.5zM5.25 7.875a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25zm0-3.75c.62 0 1.125.505 1.125 1.125S5.87 6.375 5.25 6.375 4.125 5.87 4.125 5.25 4.63 4.125 5.25 4.125zm9.704 1.08L10.5 9.658 9.046 8.205a1.125 1.125 0 00-1.591 0L3.33 12.329a1.125 1.125 0 00-.33.796v1.313c0 .31.252.562.563.562h16.875c.31 0 .562-.252.562-.563v-4.312c0-.298-.119-.585-.33-.796l-4.125-4.125a1.125 1.125 0 00-1.59 0zM19.5 13.5h-15v-.22l3.75-3.75 2.25 2.25 5.25-5.25 3.75 3.75v3.22z",
    fill: "#C4C4C4"
  })));
}

export default __webpack_public_path__ + "./fonts/image-upload-icon.85a8ddb5f1f2bca7e7a706ece07a491b.svg";
export { SvgImageUploadIcon as ReactComponent };